import { render, staticRenderFns } from "./bigDataScreen.vue?vue&type=template&id=e89edc2e&"
import script from "./bigDataScreen.vue?vue&type=script&lang=js&"
export * from "./bigDataScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports